var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "204 -824 552 648",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.62-280q-24.32 0-40.47-16.15T308-336.62v-430.76q0-24.32 16.15-40.47T364.62-824h334.76q24.32 0 40.47 16.15T756-767.38v430.76q0 24.32-16.15 40.47T699.38-280zm0-32h334.76q9.24 0 16.93-7.69t7.69-16.93v-430.76q0-9.24-7.69-16.93T699.38-792H364.62q-9.24 0-16.93 7.69T340-767.38v430.76q0 9.24 7.69 16.93t16.93 7.69m-104 136q-24.32 0-40.47-16.15T204-232.61v-462.77h32v462.77q0 9.23 7.69 16.92t16.93 7.69h366.76v32zM340-312v-480z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.db817c52c6248022b459aa4936316c45.svg";
export { ForwardRef as ReactComponent };